'use client';

import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
import NightParticleCanvas from '../components/canvas/NightParticleCanvas';
import NoiseParticleCanvas from '../components/canvas/NoiseParticleCanvas';
import { useTheme } from 'next-themes';
import { usePrefersReducedMotion } from '@/hooks/usePrefersReducedMotion';
import { useMounted } from '@/hooks/useMounted';
const FrontBackDrop: FC = () => {
  const $ = _c(3);
  const {
    resolvedTheme
  } = useTheme();
  const prefersReducedMotion = usePrefersReducedMotion();
  const mounted = useMounted();
  if (!mounted) {
    return null;
  }
  let t0;
  if ($[0] !== prefersReducedMotion || $[1] !== resolvedTheme) {
    t0 = !prefersReducedMotion && (resolvedTheme === "dark" ? <NightParticleCanvas /> : <NoiseParticleCanvas />);
    $[0] = prefersReducedMotion;
    $[1] = resolvedTheme;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default FrontBackDrop;